module.exports = __webpack_public_path__ + "media/trophy/trophy-03-df208c5f.svg";